const sweCollator = new Intl.Collator("sv");
const sweIgnoreCaseCollator = new Intl.Collator("sv", {
    sensitivity: "accent",
});

export function sweCompare(a: string, b: string): number {
    return sweCollator.compare(a, b);
}

export function sweEqualsIgnoreCase(a: string, b: string): boolean {
    return sweIgnoreCaseCollator.compare(a, b) === 0;
}
